import type Transition from '@ember/routing/transition';
import { type Registry as Services, service } from '@ember/service';
import ProtectedRoute from 'uplisting-frontend/pods/base/protected-route';
import { isRouteForbiddenWhenLapsed } from 'uplisting-frontend/router';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class PermittedRoute extends ProtectedRoute {
  @service featureFlags!: Services['feature-flags'];

  permission!: string;
  featureFlag?: string;

  async beforeModel(transition: Transition): Promise<void> {
    if (this.featureFlag && !this.featureFlags.gate.enabled(this.featureFlag)) {
      transition.abort();
      window.open('/', '_self');
      return;
    }

    await super.beforeModel(transition);

    if (transition.isAborted) {
      return;
    }

    const { session, permission } = this;

    if (!permission) {
      throw new Error('You must define `permission` property');
    }

    const currentUser = session.currentUser as ModelRegistry['user'];

    if (!this.isPermitted(currentUser)) {
      this.router.replaceWith('no-access', {
        queryParams: { denied: this.routeName },
      });

      return;
    }

    if (
      currentUser.lapsed &&
      isRouteForbiddenWhenLapsed(
        transition.targetName as string | null | undefined,
      )
    ) {
      await transition.abort();
    }
  }

  isPermitted(user: ModelRegistry['user']): boolean {
    return user.hasAccessTo(this.permission);
  }
}
